import { post } from "apiHelpers/api/ApiKit";

const AFS_API = {
    prepareAFSCheckout: (data) => post("payment-gateway/afs-payment/prepare-payment-checkout", data),
    checkAFSPaymentStatus: (data) => post("payment-gateway/afs-payment/get-payment-status", data),
    updatePaymentLinkInfo: (data) => post("payment-links/update-payment-link-status-by-cart-id", data),
}

export default AFS_API;